export default "__VITE_ASSET__Dkyzno_0__"